/**
 * Name: New Customer Saga
 * Author: @Gaurav
 * Date: 19-07-21
 */
import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
  return ApiCaller('/v1/admin/customer', 'post', payload);
};
export default function* watchRequest() {
  yield takeLatest('NEW_CUSTOMER', function* performAction(action) {
    yield put({ type: 'NEW_CUSTOMER_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'NEW_CUSTOMER_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'NEW_CUSTOMER_FAILED', payload: error });
    }
  });
}

